import { handlePushEvent } from '../helpers';
import { BannerViewProps, FilterProps } from './interfaces';

/**
 * @see {@link https://dev.azure.com/hypera/20226980%20-%20Novo%20Parceiro%20Hypera/_workitems/edit/129611|Tech Story 129611: Tageamentos client side pt.1}
 */
export function onFilter({ filterType, filterTerm }: FilterProps['params']) {
	const event: FilterProps['event'] = {
		filter_type: filterType,
		filter_term: filterTerm,
	};

	handlePushEvent('filter', event);
}

/**
 * @see {@link https://dev.azure.com/hypera/20226980%20-%20Novo%20Parceiro%20Hypera/_workitems/edit/129611|Tech Story 129611: Tageamentos client side pt.1}
 */
export function onPriorityOrdering() {
	handlePushEvent('priority_ordering');
}

/**
 * @see {@link https://dev.azure.com/hypera/20226980%20-%20Novo%20Parceiro%20Hypera/_workitems/edit/129611|Tech Story 129611: Tageamentos client side pt.1}
 */
export function onPriceOrdering() {
	handlePushEvent('price_ordering');
}

/**
 * @see {@link https://dev.azure.com/hypera/20226980%20-%20Novo%20Parceiro%20Hypera/_workitems/edit/129611|Tech Story 129611: Tageamentos client side pt.1}
 */
export function onBannerView({ name: banner_name, index }: BannerViewProps['params']) {
	const event: BannerViewProps['event'] = {
		banner_name,
		banner_position: index + 1,
	};

	handlePushEvent('banner_view', event);
}
